import { render } from "./PayslipSetting.vue?vue&type=template&id=ab81aedc"
import script from "./PayslipSetting.vue?vue&type=script&lang=js"
export * from "./PayslipSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__